import { render, staticRenderFns } from "./SpecialMarugameMemorial70.vue?vue&type=template&id=cda5a544&scoped=true"
import script from "./SpecialMarugameMemorial70.vue?vue&type=script&lang=js"
export * from "./SpecialMarugameMemorial70.vue?vue&type=script&lang=js"
import style0 from "./SpecialMarugameMemorial70.vue?vue&type=style&index=0&id=cda5a544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda5a544",
  null
  
)

export default component.exports